import * as gateway from 'sfx-web-contract';
import { AlkLogger } from '@alk/core';
import { DeepRequired } from '../../../types';
import {
    IForwardOrderRequest,
    IPendingOrderRequestWithClient,
    IPlaceOrderIdResponse,
    ISpotOrderRequest,
} from '../../../interfaces/place-order.interface';
import { IStreamData } from '../../../interfaces';

export const timeoutReject = (requestId: number): IPlaceOrderIdResponse => ({
    isAccepted: false,
    reason: 'SERVER TIMEOUT',
    requestId,
} as IPlaceOrderIdResponse);

export const encodePlaceSpotOrderRequest = (placeOrderRequest: ISpotOrderRequest): Uint8Array => {
    const request = gateway.PlaceSpotOrderRequest.create(placeOrderRequest);

    AlkLogger.debug(`[PlaceOrderAdapterService#placeSpotOrder] is encoding ${ JSON.stringify(request) } `);

    return gateway.PlaceSpotOrderRequest.encode(request).finish();
};

export const encodePlaceForwardOrderRequest =
    ({ subscriptionId, side, farPrice, nearPrice }: IForwardOrderRequest): Uint8Array => {

        const request: DeepRequired<gateway.IPlaceForwardOrderRequest> = {
            SubscriptionId: subscriptionId,
            Side: side,
            NearPrice: nearPrice,
            FarPrice: Boolean(farPrice) ? gateway.google.protobuf.DoubleValue.create({ value: farPrice }) : undefined,
        };

        AlkLogger.debug(`[PlaceOrderAdapterService#placeForwardOrder] is encoding ${ JSON.stringify(request) } `);

        return gateway.PlaceForwardOrderRequest.encode(
            gateway.PlaceForwardOrderRequest.create(request),
        ).finish();
    };

export const encodePlacePendingOrderRequest =
    (requestProps: IPendingOrderRequestWithClient): Uint8Array => {

        const request: DeepRequired<gateway.IPlacePendingOrderRequest> = {
            BaseCurrency: requestProps.baseCurrency,
            ClientId: requestProps.clientId,
            Expiry: requestProps.expiryType,
            ExpiryDate: Boolean(requestProps.expiryDate) ?
                gateway.google.protobuf.StringValue.create({ value: requestProps.expiryDate }) :
                undefined,
            Price: requestProps.triggerPrice,
            Quantity: requestProps.quantity,
            Side: requestProps.side,
            Symbol: requestProps.symbol,
            Type: requestProps.pendingType,
            PriceType: requestProps.priceType,
            PriceTypeSecondLeg: requestProps.priceTypeSecondLeg,
            SideSecondLeg: requestProps.sideSecondLeg,
            PriceSecondLeg: requestProps.triggerPriceSecondLeg,
            QuantitySecondLeg: requestProps.quantitySecondLeg,
        };

        AlkLogger.debug(`[PlaceOrderAdapterService#placePendingOrder] is encoding ${ JSON.stringify(request) } `);

        return gateway.PlacePendingOrderRequest.encode(
            gateway.PlacePendingOrderRequest.create(request),
        ).finish();
    };

export const decodePlaceSpotOrderResponse = (response: IStreamData<Uint8Array>): IPlaceOrderIdResponse => {

    const {
        Accepted: isAccepted,
        Reason: reason,
    } = gateway.PlaceSpotOrderResponse.decode(response.payload);

    return { isAccepted, reason, requestId: response.communicationToken };
};

export const decodePlaceForwardOrderResponse = (response: IStreamData<Uint8Array>): IPlaceOrderIdResponse => {

    const {
        Accepted: isAccepted,
        Reason: reason,
    } = gateway.PlaceForwardOrderResponse.decode(response.payload);

    return { isAccepted, reason, requestId: response.communicationToken };
};

export const decodePlacePendingOrderResponse = (response: IStreamData<Uint8Array>): IPlaceOrderIdResponse => {

    const {
        Accepted: isAccepted,
        Reason: reason,
    } = gateway.PlacePendingOrderResponse.decode(response.payload);

    return { isAccepted, reason, requestId: response.communicationToken };
};
